// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./userSettingsTabs.styles.css";

// function UserSettingsTabs(props) {
//   const toggles = [
//     "Customization",
//     "Profile",
//     "Environments",
//     "Users",
//     "Notification",
//   ];
//   const [toggleState, setToggleState] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   useEffect(() => {
//     const subPathname = location.pathname.split("Settings/")[1];
//     const toggleIndex = toggles.findIndex((ele) =>
//       subPathname?.startsWith(ele)
//     );
//     setToggleState(toggleIndex === -1 ? 0 : toggleIndex);
//   }, [location]);

//   const toggleTab = (index) => {
//     navigate("/dashboard/Settings/" + toggles[index]);
//   };

//   return (
//     <>
//       {/* Tab Buttons */}
//       <div className="settings-selector-container">
//         <button
//           className={
//             toggleState === 0 ? "setting-selector-active" : "setting-selector"
//           }
//           onClick={() => toggleTab(0)}
//         >
//           Customization
//         </button>
//         <button
//           className={
//             toggleState === 1 ? "setting-selector-active" : "setting-selector"
//           }
//           onClick={() => toggleTab(1)}
//         >
//           Profile
//         </button>
//         <button
//           className={
//             toggleState === 2 ? "setting-selector-active" : "setting-selector"
//           }
//           onClick={() => toggleTab(2)}
//         >
//           Environments
//         </button>
//         <button
//           className={
//             toggleState === 3 ? "setting-selector-active" : "setting-selector"
//           }
//           onClick={() => toggleTab(3)}
//         >
//           Users
//         </button>
//         <button
//           className={
//             toggleState === 4 ? "setting-selector-active" : "setting-selector"
//           }
//           onClick={() => toggleTab(4)}
//         >
//           Notification
//         </button>
//       </div>
//     </>
//   );
// }

// export default UserSettingsTabs;

import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import { STRIPE_PUBLIC_KEY } from "../../../../config";
import "./userSettingsTabs.styles.css";

function UserSettingsTabs() {
  const toggles = useMemo(() => {
    const baseToggles = [
      "Customization",
      "Profile",
      "Users",
      "Notification",
    ];

    if (STRIPE_PUBLIC_KEY) {
      baseToggles.push("Billing");
    }

    return baseToggles;
  }, [STRIPE_PUBLIC_KEY]);

  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("0");

  // Sync active tab with URL
  useEffect(() => {
    const subPathname = location.pathname.split("Settings/")[1];
    const toggleIndex = toggles.findIndex((ele) =>
      subPathname?.startsWith(ele)
    );
    setActiveKey(toggleIndex === -1 ? "0" : String(toggleIndex));
  }, [location, toggles]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    navigate(`/dashboard/Settings/${toggles[Number(key)]}`);
  };

  return (
    <Tabs
      style={{ paddingLeft: "32px" }}
      size="large"
      activeKey={activeKey}
      onChange={handleTabChange}
      items={toggles.map((label, index) => ({
        key: String(index),
        label: label,
      }))}
    />
  );
}

export default UserSettingsTabs;
